import ContainerSignInPhoneOTP from "./Components/ContainerSignInPhoneOTP"
export default function SignInPhoneOTP() {
  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerSignInPhoneOTP text="ورود به حساب کاربری"/>
      <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  )
}